const prodAnim = {
  init() {
    /* Smooth content */

    
    ScrollSmoother.create({
      wrapper: "#smooth-container",
      content: "#smooth-content",
      smooth: 1,
      effects: true,
    });


    const btnSynopsis = document.querySelector(".btn-synopsis");
    const mobileSynopsis = document.querySelector(".prod-synopsis-mobile");
    btnSynopsis.addEventListener('click', (e) => {
      if (e.currentTarget.classList.contains("opened")) {
        mobileSynopsis.style.maxHeight = "0";
        btnSynopsis.classList.remove('opened');
      } else {
        mobileSynopsis.style.maxHeight = mobileSynopsis.scrollHeight + "px";
        btnSynopsis.classList.add('opened');
      }
    })

    const togglers = document.querySelectorAll("[data-toggle]");

      togglers.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          const selector = e.currentTarget.dataset.toggle;
          const button = e.currentTarget.childNodes[1].childNodes[1];
          const block = document.querySelector(`${selector}`);
          //console.log(button);
          if (e.currentTarget.classList.contains("active")) {
            block.style.maxHeight = "";
            button.classList.remove('opened');
          } else {
            block.style.maxHeight = block.scrollHeight + "px";
            button.classList.add('opened');
          }

          e.currentTarget.classList.toggle("active");
        });
      });
      
    
    

    gsap.from(".prod-fullscreen-infos h1, .prod-fullscreen-infos h2, .prod-fullscreen-infos .prod-info, .prod-info-double", {
      scrollTrigger: {
        trigger: "#production",
        start: "top center",
        scrub: false,
        end: "+=100%",
        markers: false,
      },
      y: 200,
      opacity: 0,
      stagger: 0.3,
      duration: 0.8,
    });

    
    /* END OF PAGE ANIMATION */

    gsap.to(".section-tabs", {
      scrollTrigger: {
        trigger: "footer",
        start: "top bottom",
        scrub: true,
        end: "+=100%",
        markers: false,
      },
      width: "98%",
    });
    const tabsContainer = document.querySelector(".tabs-container");
    const tabsList = tabsContainer.querySelector("ul");
    const tabButtons = tabsList.querySelectorAll("a");
    const tabPanels = tabsContainer.querySelectorAll(".tabs__panels > div");

    tabsList.setAttribute("role", "tablist");

    tabsList.querySelectorAll("li").forEach((listitem) => {
      listitem.setAttribute("role", "presentation");
    });

    tabButtons.forEach((tab, index) => {
      tab.setAttribute("role", "tab");
      if (index === 0) {
        tab.setAttribute("aria-selected", "true");
        // we'll add something here
      } else {
        tab.setAttribute("tabindex", "-1");
        tabPanels[index].setAttribute("hidden", "");
      }
    });

    tabPanels.forEach((panel) => {
      panel.setAttribute("role", "tabpanel");
      panel.setAttribute("tabindex", "0");
    });

    tabsContainer.addEventListener("click", (e) => {
      const clickedTab = e.target.closest("a");
      if (!clickedTab) return;
      e.preventDefault();

      switchTab(clickedTab);
    });

    tabsContainer.addEventListener("keydown", (e) => {
      switch (e.key) {
        case "ArrowLeft":
          moveLeft();
          break;
        case "ArrowRight":
          moveRight();
          break;
        case "Home":
          e.preventDefault();
          switchTab(tabButtons[0]);
          break;
        case "End":
          e.preventDefault();
          switchTab(tabButtons[tabButtons.length - 1]);
          break;
      }
    });

    function moveLeft() {
      const currentTab = document.activeElement;
      if (!currentTab.parentElement.previousElementSibling) {
        switchTab(tabButtons[tabButtons.length - 1]);
      } else {
        switchTab(
          currentTab.parentElement.previousElementSibling.querySelector("a")
        );
      }
    }

    function moveRight() {
      const currentTab = document.activeElement;
      if (!currentTab.parentElement.nextElementSibling) {
        switchTab(tabButtons[0]);
      } else {
        switchTab(
          currentTab.parentElement.nextElementSibling.querySelector("a")
        );
      }
    }

    function switchTab(newTab) {
      const activePanelId = newTab.getAttribute("href");
      const activePanel = tabsContainer.querySelector(activePanelId);

      tabButtons.forEach((button) => {
        button.setAttribute("aria-selected", false);
        button.setAttribute("tabindex", "-1");
      });

      tabPanels.forEach((panel) => {
        panel.setAttribute("hidden", true);
      });

      activePanel.removeAttribute("hidden", false);

      newTab.setAttribute("aria-selected", true);
      newTab.setAttribute("tabindex", "0");
      newTab.focus();
    }

    const not_active_slide_scale_value = 0.85;
    const not_active_slide_opacity_value = 0.4;

    var swiper_scale_active = new Swiper("[swiper_scale_active]", {
      pagination: {
        el: ".swiper-pagination-prod",
        clickable: true,
      },
      slidesPerView: 1.5,
      parallax: true,
      loop: true,
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 320px
        320: {
          speed: 900 /* Duration of transition between slides (in ms) */,
          slidesPerView: 1.2,
        },
        // when window width is >= 640px
        640: {
          speed: 1400,
        },
      },
      keyboard: {
        enabled: true,
      },
      centeredSlides: true,
      loop: true,
      slideToClickedSlide: true,
      spaceBetween: -150,
      grabCursor: true,
      /*
          autoplay: {
            delay: 4000,
          },*/

      effect: "creative",
      creativeEffect: {
        limitProgress: 4, // slides after 2nd before/after active will have same state
        prev: {
          opacity: not_active_slide_opacity_value,
          scale: not_active_slide_scale_value,
          // will set `translateX(-90%)` on previous slides
          translate: ["-20%", 0, 0],
        },
        next: {
          opacity: not_active_slide_opacity_value,
          scale: not_active_slide_scale_value,
          // will set `translateX(90%)` on next slides
          translate: ["20%", 0, 0],
        },
      },
    });

    /* CUSTOM ARROWS CODE (5 click on next will change 5 slides - so speed:0) */

    //console.log(swiper_scale_active);

    const prev = document.querySelector(".swiper-button-prev-prod");
    prev.addEventListener("click", prev_slide);
    /* add aria controls (web accessibility) */

    const next = document.querySelector(".swiper-button-next-prod");
    next.addEventListener("click", next_slide);

    function prev_slide() {
      swiper_scale_active.slidePrev(0);
    }

    function next_slide() {
      swiper_scale_active.slideNext(0);
    }

    add_aria_for_navigation();

    /* we use custom arrows - so we need to set aria mannualy (For screenreaders) */
    function add_aria_for_navigation() {
      /* The global aria-controls property identifies the element (or elements) whose contents or presence are controlled by the element on which this attribute is set.*/
      const this_slider = document.querySelector(
        "[swiper_scale_active] .swiper-wrapper"
      );
      const id_value = "my_swiper_scale_active"; /* use any value you want */
      this_slider.setAttribute("id", id_value);
      prev.setAttribute("aria-controls", id_value);
      next.setAttribute("aria-controls", id_value);

      prev.setAttribute("aria-label", "Previous slid");
      next.setAttribute("aria-label", "Next Slide");
    }
  },
};

export default prodAnim;
